module.exports = Promise.resolve(parcelRequire("2BItW"))